import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { dataToDropDownConverter } from "../../../../../helpers";
import { MultiselectDropdown } from "../../multiselect-dropdown";
import { useStore, useTranslation } from "../../../../../hooks";
import { DropdownOptionValue } from "../../dropdown/models";
import { T } from "../../../../../constants";
import { Dropdown } from "../../dropdown";

interface BusinessFilterProps {
  hasAll?: boolean;
  partnerId: number;
  isMulti?: boolean;
  multiValue?: Array<number>;
  value?: DropdownOptionValue;
  onChange?: (value?: DropdownOptionValue | Array<DropdownOptionValue>) => void;
}

export const BusinessFilter: React.FC<BusinessFilterProps> = observer(({
   value,
   hasAll,
   isMulti,
   onChange,
   partnerId,
   multiValue = [],
}) => {
    const t = useTranslation();
    const { partnerStore } = useStore();

    const { partnerBusiness: { data } } = partnerStore;

    const businessData = useMemo(() => {
      return data
        ? dataToDropDownConverter(data.items, {
            labelKey: "name",
            valueKey: "id",
          })
        : [];
    }, [data, partnerId]);

    return (
      <>
        {
          isMulti ? (
            <MultiselectDropdown
              withSearch
              value={multiValue}
              data={businessData}
              label={t(T.BUSINESS)}
              showSelectAll={hasAll}
              onChange={(data) => onChange?.(data as Array<number>)}
            />
          ) : (
            <Dropdown
              value={value}
              hasAll={hasAll}
              onChange={onChange}
              data={businessData}
              label={t(T.BUSINESS)}
              withSearch={!!businessData.length}
            />
          )
        }
      </>
    );
  },
);
